import { Button } from '@/components/ui';
import { cn } from '@/utils/cn';

export type BroadcastHistoryView = 'manual' | 'auto';

interface BroadcastHistoryViewSelectorProps {
  value: BroadcastHistoryView;
  onChange: (value: BroadcastHistoryView) => void;
}

const OPTIONS: Array<{ value: BroadcastHistoryView; title: string; description: string }> = [
  {
    value: 'manual',
    title: 'Ручные',
    description: 'Журнал уже отправленных ручных рассылок',
  },
  {
    value: 'auto',
    title: 'Автоматические',
    description: 'Журнал уже отправленных авто и cron сообщений',
  },
];

export function BroadcastHistoryViewSelector({ value, onChange }: BroadcastHistoryViewSelectorProps) {
  return (
    <div className="rounded-lg border bg-white p-2">
      <div className="grid gap-2 md:grid-cols-2">
        {OPTIONS.map((option) => {
          const active = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={cn(
                'rounded-lg border px-4 py-3 text-left transition-colors',
                active ? 'border-primary-300 bg-primary-50' : 'border-neutral-200 hover:bg-neutral-50'
              )}
            >
              <div className="flex items-center justify-between gap-3">
                <div>
                  <div className="font-semibold text-neutral-900">{option.title}</div>
                  <div className="mt-1 text-sm text-neutral-600">{option.description}</div>
                </div>
                <Button
                  variant={active ? 'primary' : 'ghost'}
                  size="sm"
                  className="pointer-events-none"
                >
                  {active ? 'Выбрано' : 'Показать'}
                </Button>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
